import { Field } from 'react-final-form';
import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { isNil } from 'lodash';
import { useCallback } from 'react';
import { StringUtil } from '../../utils';

export const FormInput = ({
  name,
  label,
  disabled,
  required,
  inputProps,
  fieldProps,
  helperText,
  showErrorUntouched = false,
  onBlur,
  maxLength,
  onChange,
  value,
  ...props
}) => {
  const { parse, ...restFieldProps } = fieldProps || {};

  const handleParse = useCallback(
    value => {
      let result = value;

      if (maxLength) {
        result = StringUtil.restrictToLimit(value, maxLength);
      }
      if (parse) {
        result = parse(result);
      }

      return result;
    },
    [parse]
  );

  return (
    <Field name={name} parse={handleParse} allowNull {...restFieldProps}>
      {({ input, meta }) => {
        const isError = meta.error && (meta.touched || showErrorUntouched);

        return (
          <TextField
            {...input}
            value={!value ? input.value ?? '' : value} // 👈 Force controlled value for MUI to re-render
            label={label}
            disabled={disabled}
            required={required}
            inputProps={{ maxLength, ...inputProps }}
            error={isError}
            helperText={isError ? meta.error : helperText}
            InputLabelProps={{
              shrink: !!input.value || !!value || !!meta.active,
            }}
            onChange={e => {
              input.onChange(e);
              onChange?.(e);
            }}
            onBlur={e => {
              if (isNil(input.value)) {
                input.onChange({ ...e, target: { ...e.target, value: '' } });
              }
              input.onBlur(e);
              onBlur?.(e);
            }}
            key={name}
            {...props}
          />
        );
      }}
    </Field>
  );
};

FormInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  key: PropTypes.string,
  inputProps: PropTypes.object,
  fieldProps: PropTypes.object,
  helperText: PropTypes.string,
  showErrorUntouched: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  maxLength: PropTypes.number,
  value: PropTypes.string,
};
